import { Container, Label } from 'components/atoms';
import { FormInput } from 'components/molecules';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import HeaderStatusWrapper from 'components/molecules/headerStatusWrapper/HeaderStatusWrapper';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiEye, PiImage, PiUsers, PiVideoCamera } from 'react-icons/pi';
import { IChannelMutationForm } from 'services/channel/types/query';

const ChannelData = () => {
  const { t } = useTranslation();

  const {
    values,
    setFieldValue,
    status,
    initialValues,
    errors,
  }: IFormikContextType<IChannelMutationForm> = useFormikContext<IChannelMutationForm>();

  return (
    <DataWrapper>
      <Container className="w-max">
        <Container.Header
          title={
            <>
              <PiImage /> {t('input.label.image')}
            </>
          }
        />
        <Container.Content className="items-center">
          <img src={values.imageLink} style={{ height: 160, borderRadius: '0.5rem' }} />
        </Container.Content>
      </Container>
      <Container>
        <Container.Header
          title={
            <>
              <PiVideoCamera /> {t('channel.tabs.data')}
            </>
          }
        />

        <Container.Content>
          <FormInput.Text displayMode={true} name="name" label={t('input.label.name')} />
          <FormInput.Text
            displayMode={true}
            name="externalChannelId"
            label={t('channel.input.externalChannelId')}
          />
          <FormInput.Text displayMode={true} name="link" label={t('channel.input.link')} />
        </Container.Content>
      </Container>{' '}
      <HeaderStatusWrapper title={t('channel.label.subscribers')}>
        <Label title="Subscribers" size="compact" withText fullWidth>
          <PiUsers /> {values.subscribersCount.toLocaleString()}
        </Label>
      </HeaderStatusWrapper>
      <HeaderStatusWrapper title={t('channel.label.views')}>
        <Label title="Views" size="compact" withText fullWidth>
          <PiEye /> {values.totalViews.toLocaleString()}
        </Label>
      </HeaderStatusWrapper>
      <HeaderStatusWrapper title={t('channel.label.videos')}>
        <Label title="Videos" size="compact" withText fullWidth>
          <PiVideoCamera /> {values.totalVideoCount.toLocaleString()}
        </Label>
      </HeaderStatusWrapper>
    </DataWrapper>
  );
};

export default ChannelData;
